import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import ProOnboardingCTA from '../../../UserPage/components/ProUserPage/components/ProOnboardingCTA';
import { isAlbumFolder } from '../../../../../../util/album-folder';
import { ContributorActions } from '../../../../../pro/views/AutoContributorLinkHandler/components/ContributorActionsModal';
import { ALBUM_TYPE } from '../../../../../../constants/albums';
import { BASENAME } from '../../../../../../constants/basenames';
import inIframe from '../../../../../../util/in-iframe';
import getConfig from '../../../../../../util/config';
import { isWeddingsContent } from '../../../../../../util/album';

const propTypes = {
  joinCodeItem: PropTypes.object.isRequired,
  authenticated: PropTypes.bool,
};

const JoinCodeResultListing = ({ joinCodeItem, authenticated }) => {
  const history = useHistory();
  const albumFolder = isAlbumFolder(joinCodeItem) ? joinCodeItem : null;
  const album = !isAlbumFolder(joinCodeItem) ? joinCodeItem : null;

  const isWedding = isWeddingsContent(albumFolder) || isWeddingsContent(album);
  const isShutterbug =
    albumFolder?.album_type === ALBUM_TYPE.SHUTTERBUG ||
    album?.album_type === ALBUM_TYPE.SHUTTERBUG;
  const entity = albumFolder ?? album;
  const redirectPath = authenticated
    ? `/app/${BASENAME.SHUTTERBUG}/hierarchy-items/${entity.id}`
    : `/galleries/view/${albumFolder ? 'folder' : 'album'}/${entity.id}`;

  return (
    <div className="album-search-join-code-result">
      {isShutterbug || isWedding ? (
        <ContributorActions
          entity={entity}
          onViewPhotos={() => {
            if (inIframe()) {
              window.open(
                `${getConfig().app.baseUrl}${redirectPath}`,
                '_blank',
              );
            } else {
              history.push(redirectPath);
            }
          }}
        />
      ) : (
        <ProOnboardingCTA
          hierarchyItem={{
            id: albumFolder?.id ?? album?.id,
            name: albumFolder?.name ?? album?.name,
            album_folder: albumFolder,
            album,
            root_album_folder: {
              id: albumFolder?.root?.id ?? album?.root_album_folder?.id,
              all_photos_mode: albumFolder?.root?.all_photos_mode,
            },
            join_code_access: true,
          }}
          actionProps={{ requireUserInteraction: false }}
        />
      )}
    </div>
  );
};

JoinCodeResultListing.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(connect(mapStateToProps))(JoinCodeResultListing);
